import React, { ForwardedRef, forwardRef } from 'react';
import Button, { ButtonProps } from '../../elements/button/button';
import cn from 'classnames';

import styles from './social.module.scss';
import Facebook2Icon from '../../icons/facebook2-icon';
import GoogleIcon from '../../icons/google-icon';
import AppleIcon from '../../icons/apple-icon';

export const FacebookButton = forwardRef(
  (
    { className, ...props }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <Button
        className={cn(styles.btnFacebook, className)}
        {...props}
        ref={ref}
      >
        <Facebook2Icon className={styles.facebookIcon} /> Facebook
      </Button>
    );
  },
);

FacebookButton.displayName = 'FacebookButton';

export const GoogleButton = forwardRef(
  (
    { className, ...props }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <Button className={cn(styles.btnGoogle, className)} {...props} ref={ref}>
        <GoogleIcon className={styles.googleIcon} /> Google
      </Button>
    );
  },
);

GoogleButton.displayName = 'GoogleButton';

export const AppleButton = forwardRef(
  (
    { className, ...props }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <Button className={cn(styles.btnApple, className)} {...props} ref={ref}>
        <AppleIcon className={styles.appleIcon} /> Sign in with Apple
      </Button>
    );
  },
);

AppleButton.displayName = 'AppleButton';
